<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center px-4">
    <div class="max-w-md w-full text-center">
      <!-- Icône 404 -->
      <div class="mb-8">
        <div class="text-9xl font-bold text-gray-300 mb-4">404</div>
        <div class="w-24 h-1 bg-gradient-to-r from-blue-500 to-indigo-600 mx-auto rounded-full"></div>
      </div>

      <!-- Message d'erreur -->
      <h1 class="text-3xl font-bold text-gray-800 mb-4">
        Page introuvable
      </h1>
      <p class="text-gray-600 mb-8">
        Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
      </p>

      <!-- Actions -->
      <div class="space-y-4">
        <button
          class="w-full bg-gray-600 hover:bg-gray-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
          @click="goBack"
        >
          ← Retour en arrière
        </button>
        
        <router-link
          to="/"
          class="block w-full bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-105"
        >
          Accueil
        </router-link>


      </div>

      <!-- URL demandée -->
      <div class="mt-8 p-4 bg-gray-50 rounded-lg">
        <p class="text-sm text-gray-500 mb-2">URL demandée :</p>
        <p class="text-xs text-gray-400 font-mono break-all">
          {{ currentPath }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const router = useRouter()
const route = useRoute()

const currentPath = computed(() => route.fullPath)

const goBack = () => {
  if (window.history.length > 1) {
    router.go(-1)
  } else {
    router.push('/')
  }
}
</script> 